import { render, staticRenderFns } from "./periodLockMain.vue?vue&type=template&id=4a60e72e&scoped=true&"
import script from "./periodLockMain.vue?vue&type=script&lang=js&"
export * from "./periodLockMain.vue?vue&type=script&lang=js&"
import style0 from "./periodLockMain.vue?vue&type=style&index=0&id=4a60e72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60e72e",
  null
  
)

export default component.exports